import { Environment } from './environment.types';

export const environment: Environment = {
  baseAPI: 'https://breeze-v2-backend-dev.secureid-digital.com.ng/api',
  engageKey: 'pk_70302f63b618b3d9155e49e55b4e9cc0',
};
